var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetLinkSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 570,
    height: 283,
    viewBox: "0 0 570 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H550C561.046 0 570 8.95431 570 20V283H0V20Z",
    fill: "#FFF8EC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_10",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 570,
    height: 283
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H550C561.046 0 570 8.95431 570 20V283H0V20Z",
    fill: "#F2E0BC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_10)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.797 253.275H222.848L222.848 68.8461H172.797L172.797 253.275Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.559 253.275H211.61L211.61 68.8461H161.559L161.559 253.275Z",
    fill: "#FAA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.594 80.5829H161.556V93.8937H211.594V80.5829Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.594 109.458H161.556V122.772H211.594V109.458Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.594 138.329H161.556V151.64H211.594V138.329Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.594 167.201H161.556V180.512H211.594V167.201Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.594 196.076H161.556V209.387H211.594V196.076Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.594 224.948H161.556V238.258H211.594V224.948Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7866 253.275H142.838L142.838 90.0082H92.7866L92.7866 253.275Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5455 253.275H131.597L131.597 90.0082H81.5455L81.5455 253.275Z",
    fill: "#FAA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.581 105.019H81.5426V116.446H131.581V105.019Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.581 129.809H81.5426V141.236H131.581V129.809Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.581 154.595H81.5426V166.023H131.581V154.595Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.581 179.382H81.5426V190.81H131.581V179.382Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.581 204.169H81.5426V215.597H131.581V204.169Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.581 228.956H81.5426V240.383H131.581V228.956Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.938 246.21H228.979V275.139H249.938V246.21Z",
    fill: "#A2C5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.856 285.978C598.232 247.224 604.547 206.525 579.887 171.547C562.37 147.278 539.201 132.648 518.078 113.362H472.189V63.2997H440.493V95.7993H433.263V57H401.567V129.741H361.478V172.162H346.502V182.843H312.095V164.439H292.343V114.441H267.94V206.741H243.541V285.885L578.856 285.978Z",
    fill: "#FAA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.266 61.9122H401.55V69.3224H433.266V61.9122Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.266 75.8347H401.55V83.245H433.266V75.8347Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.266 88.3601H401.55V95.7704H433.266V88.3601Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.182 88.3601H440.467V95.7704H472.182V88.3601Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.182 75.8347H440.467V83.245H472.182V75.8347Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.182 63.3287H440.467V70.7389H472.182V63.3287Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.192 100.506H401.55V107.916H472.192V100.506Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.192 112.654H401.55V120.065H472.192V112.654Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.567 114.447H267.953V125.888H292.567V114.447Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.567 131.463H267.953V142.904H292.567V131.463Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.567 148.476H267.953V159.916H292.567V148.476Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.567 166.309H267.953V177.75H292.567V166.309Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.567 183.593H267.953V195.033H292.567V183.593Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.567 200.873H267.953V212.313H292.567V200.873Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.567 218.954H267.953V230.395H292.567V218.954Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.192 124.523H401.55V129.229H472.192V124.523Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.304 114.447H292.227V164.442H301.304V114.447Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.353 164.443H312.095V182.843H330.353V164.443Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.183 63.3287V70.7422L472.189 100.509V107.922V113.366H478.481V63.9178C478.198 63.7182 477.915 63.525 477.633 63.3287H472.179H472.183Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.133 57H433.266V95.7703H437.133V57Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.403 137.039H368.03V144.207H373.403V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.453 137.039H378.079V144.207H383.453V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.277 137.039H387.904V144.207H393.277V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.591 137.039H397.218V144.207H402.591V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.082 137.039H406.709V144.207H412.082V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.685 137.039H416.311V144.207H421.685V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.734 137.039H426.361V144.208H431.734V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.558 137.039H436.185V144.208H441.558V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.873 137.039H445.499V144.208H450.873V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.363 137.039H454.99V144.208H460.363V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.258 137.039H464.885V144.207H470.258V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.305 137.039H474.932V144.208H480.305V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.129 137.039H484.756V144.208H490.129V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.443 137.039H494.07V144.208H499.443V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.937 137.039H503.564V144.208H508.937V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.537 137.039H513.164V144.208H518.537V137.039Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.403 149.69H368.03V156.858H373.403V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.452 149.69H378.079V156.858H383.452V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.277 149.69H387.904V156.858H393.277V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.591 149.69H397.218V156.858H402.591V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.082 149.69H406.708V156.858H412.082V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.684 149.69H416.311V156.858H421.684V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.734 149.69H426.361V156.859H431.734V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.558 149.69H436.185V156.859H441.558V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.872 149.69H445.499V156.859H450.872V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.363 149.69H454.99V156.859H460.363V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.258 149.69H464.885V156.858H470.258V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.305 149.69H474.932V156.859H480.305V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.129 149.69H484.756V156.859H490.129V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.443 149.69H494.07V156.859H499.443V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.937 149.69H503.564V156.859H508.937V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.537 149.69H513.163V156.859H518.537V149.69Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.403 162.147H368.03V169.316H373.403V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.452 162.147H378.079V169.316H383.452V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.277 162.147H387.904V169.316H393.277V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.591 162.147H397.218V169.316H402.591V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.082 162.147H406.708V169.316H412.082V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.684 162.147H416.311V169.316H421.684V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.734 162.147H426.361V169.316H431.734V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.558 162.147H436.185V169.316H441.558V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.872 162.147H445.499V169.316H450.872V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.363 162.147H454.99V169.316H460.363V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.258 162.147H464.885V169.316H470.258V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.305 162.147H474.932V169.316H480.305V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.129 162.147H484.756V169.316H490.129V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.443 162.147H494.07V169.316H499.443V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.937 162.147H503.564V169.316H508.937V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.537 162.147H513.163V169.316H518.537V162.147Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.403 175.381H368.03V182.55H373.403V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.452 175.381H378.079V182.55H383.452V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.277 175.381H387.904V182.55H393.277V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.591 175.381H397.218V182.55H402.591V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.082 175.381H406.708V182.55H412.082V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.684 175.381H416.311V182.55H421.684V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.734 175.381H426.361V182.55H431.734V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.558 175.381H436.185V182.55H441.558V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.872 175.381H445.499V182.55H450.872V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.363 175.381H454.99V182.55H460.363V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.258 175.381H464.885V182.55H470.258V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.305 175.381H474.932V182.55H480.305V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.129 175.381H484.756V182.55H490.129V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.443 175.381H494.07V182.55H499.443V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.937 175.381H503.564V182.55H508.937V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.537 175.381H513.163V182.55H518.537V175.381Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.403 188.032H368.03V195.201H373.403V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.452 188.032H378.079V195.201H383.452V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.277 188.032H387.903V195.201H393.277V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.591 188.032H397.218V195.201H402.591V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.081 188.032H406.708V195.201H412.081V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.684 188.032H416.311V195.201H421.684V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.734 188.032H426.361V195.201H431.734V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.558 188.032H436.185V195.201H441.558V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.872 188.032H445.499V195.201H450.872V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.363 188.032H454.99V195.201H460.363V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.258 188.032H464.885V195.201H470.258V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.305 188.032H474.931V195.201H480.305V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.129 188.032H484.756V195.201H490.129V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.443 188.032H494.07V195.201H499.443V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.937 188.032H503.564V195.201H508.937V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.536 188.032H513.163V195.201H518.536V188.032Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.403 200.486H368.03V207.655H373.403V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.452 200.486H378.079V207.655H383.452V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.277 200.486H387.903V207.655H393.277V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.591 200.486H397.218V207.655H402.591V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.081 200.486H406.708V207.655H412.081V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.684 200.486H416.311V207.655H421.684V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.734 200.486H426.361V207.655H431.734V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.558 200.486H436.185V207.655H441.558V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.872 200.486H445.499V207.655H450.872V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.363 200.486H454.99V207.655H460.363V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.258 200.486H464.885V207.655H470.258V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.305 200.486H474.931V207.655H480.305V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.129 200.486H484.756V207.655H490.129V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.443 200.486H494.07V207.655H499.443V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.937 200.486H503.564V207.655H508.937V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.536 200.486H513.163V207.655H518.536V200.486Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.9 222.945H330.353V286.541H454.9V222.945Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46 254.743H235.913V286.541H360.46V254.743Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.876 230.394H338.672V242.173H361.876V230.394Z",
    fill: "#FAA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.665 230.394H368.46V242.173H391.665V230.394Z",
    fill: "#FAA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.885 230.394H397.68V242.173H420.885V230.394Z",
    fill: "#FAA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.543 230.394H426.338V242.173H449.543V230.394Z",
    fill: "#FAA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.5 109.471H272.851V114.45H273.5V109.471Z",
    fill: "#A2C5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.759 109.471H296.11V114.45H296.759V109.471Z",
    fill: "#A2C5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.355 231.592H168.84V286.026H254.355V231.592Z",
    fill: "#FAA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.355 224.481H168.84V242.173H254.355V224.481Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.053 247.417H174.663V253.275H179.053V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.265 247.417H182.875V253.275H187.265V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.294 247.417H190.904V253.275H195.294V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.906 247.417H198.516V253.275H202.906V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.666 247.417H206.275V253.275H210.666V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.512 247.417H214.122V253.275H218.512V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.728 247.417H222.337V253.275H226.728V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.753 247.417H230.363V253.275H234.753V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.369 247.417H237.978V253.275H242.369V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.128 247.417H245.738V253.275H250.128V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.053 257.756H174.663V263.615H179.053V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.265 257.756H182.875V263.615H187.265V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.294 257.756H190.904V263.615H195.294V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.906 257.756H198.516V263.615H202.906V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.666 257.756H206.275V263.615H210.666V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.512 257.756H214.122V263.615H218.512V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.727 257.756H222.337V263.615H226.727V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.753 257.756H230.363V263.615H234.753V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.369 257.756H237.978V263.615H242.369V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.128 257.756H245.738V263.615H250.128V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.053 267.935H174.663V273.794H179.053V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.265 267.935H182.875V273.793H187.265V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.294 267.935H190.904V273.793H195.294V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.906 267.935H198.516V273.793H202.906V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.666 267.935H206.275V273.793H210.666V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.512 267.935H214.122V273.793H218.512V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.727 267.935H222.337V273.793H226.727V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.753 267.935H230.363V273.793H234.753V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.369 267.935H237.978V273.793H242.369V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.128 267.935H245.738V273.793H250.128V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.602 231.592H83.087V286.026H168.602V231.592Z",
    fill: "#FAA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.602 224.481H83.087V242.173H168.602V224.481Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3004 247.417H88.91V253.275H93.3004V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.513 247.417H97.1222V253.275H101.513V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.542 247.417H105.151V253.275H109.542V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.154 247.417H112.763V253.275H117.154V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.913 247.417H120.523V253.275H124.913V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.762 247.417H128.372V253.275H132.762V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.975 247.417H136.585V253.275H140.975V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.004 247.417H144.614V253.275H149.004V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.616 247.417H152.226V253.275H156.616V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.376 247.417H159.985V253.275H164.376V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3003 257.756H88.9099V263.615H93.3003V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.512 257.756H97.1221V263.615H101.512V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.541 257.756H105.151V263.615H109.541V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.154 257.756H112.763V263.615H117.154V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.913 257.756H120.523V263.615H124.913V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.762 257.756H128.372V263.615H132.762V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.975 257.756H136.584V263.615H140.975V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.004 257.756H144.613V263.615H149.004V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.616 257.756H152.226V263.615H156.616V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.375 257.756H159.985V263.615H164.375V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3003 267.935H88.9099V273.794H93.3003V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.512 267.935H97.1221V273.793H101.512V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.541 267.935H105.151V273.793H109.541V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.154 267.935H112.763V273.793H117.154V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.913 267.935H120.523V273.793H124.913V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.762 267.935H128.372V273.793H132.762V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.975 267.935H136.584V273.793H140.975V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.004 267.935H144.613V273.793H149.004V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.616 267.935H152.226V273.793H156.616V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.375 267.935H159.985V273.793H164.375V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5149 231.592H-8V286.026H77.5149V231.592Z",
    fill: "#FAA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5149 224.481H-8V242.173H77.5149V224.481Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2134 247.417H-2.177V253.275H2.2134V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4256 247.417H6.03516V253.275H10.4256V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4546 247.417H14.0641V253.275H18.4546V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0667 247.417H21.6763V253.275H26.0667V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8261 247.417H29.4357V253.275H33.8261V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6754 247.417H37.285V253.275H41.6754V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8878 247.417H45.4974V253.275H49.8878V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9168 247.417H53.5264V253.275H57.9168V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.529 247.417H61.1386V253.275H65.529V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2884 247.417H68.898V253.275H73.2884V247.417Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21322 257.756H-2.17719V263.615H2.21322V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4254 257.756H6.03497V263.615H10.4254V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4544 257.756H14.064V263.615H18.4544V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0666 257.756H21.6761V263.615H26.0666V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8259 257.756H29.4355V263.615H33.8259V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6752 257.756H37.2848V263.615H41.6752V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8877 257.756H45.4973V263.615H49.8877V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9166 257.756H53.5262V263.615H57.9166V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5288 257.756H61.1384V263.615H65.5288V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2882 257.756H68.8978V263.615H73.2882V257.756Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21322 267.935H-2.17719V273.794H2.21322V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4254 267.935H6.03497V273.793H10.4254V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4544 267.935H14.064V273.793H18.4544V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0666 267.935H21.6761V273.793H26.0666V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8259 267.935H29.4355V273.793H33.8259V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6752 267.935H37.2848V273.793H41.6752V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8877 267.935H45.4973V273.793H49.8877V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9166 267.935H53.5262V273.793H57.9166V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5288 267.935H61.1384V273.793H65.5288V267.935Z",
    fill: "#FFE49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2882 267.935H68.8978V273.793H73.2882V267.935Z",
    fill: "#FFE49F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134 283L-15.0146 282.959C-15.0146 282.959 -19.7707 271.8 -26 253.369C-19.0503 251.764 0.142784 248.278 13.5152 254.852C30.1099 263.013 27.9379 273.871 48.493 269.891C69.0445 265.911 85.9975 264.24 95.2016 269.891C104.406 275.538 111.162 273.293 122.61 273.259C132.1 273.231 133.724 280.514 134 283Z",
    fill: "#0EA35B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 54.4082C206 54.4082 210.551 40.0541 221.43 41.6459C221.43 41.6459 237.228 17.7211 254.072 38.4544C254.072 38.4544 271.978 33.315 285.238 42.9018C294.079 49.2929 297 56 297 56L216.484 54.0785L206 54.4082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 78.4082C72 78.4082 76.5509 64.0541 87.43 65.6459C87.43 65.6459 103.228 41.7211 120.072 62.4544C120.072 62.4544 137.978 57.315 151.238 66.9018C160.079 73.2929 163 80 163 80L82.4842 78.0785L72 78.4082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.067 281.471C489.347 278.796 484.162 271.856 477.263 272.774C469.745 273.774 485.566 278.68 490.409 281.491C489.332 281.506 488.408 281.42 487.73 281.183C484.489 280.042 478.947 282.233 477.171 283H508C507.786 282.268 507.229 281.077 505.795 280.209C505.29 279.901 504.269 279.861 502.958 279.957C504.79 277.822 506.066 270.993 500.963 272.749C497.232 274.031 497.242 278.205 497.61 280.673C496.819 280.794 496.012 280.921 495.216 281.032C493.68 273.294 488.25 250.617 477.247 250.011C466.091 249.401 486.709 273.526 493.573 281.244C492.695 281.35 491.848 281.425 491.062 281.466L491.067 281.471Z",
    fill: "#0EA35B"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.304 131.582H186.773L186.682 131.584C185.745 131.631 185 132.407 185 133.354C185 133.354 185 203.136 185 229.706C185 239.809 193.19 247.999 203.292 247.999C240.675 247.999 331.401 247.999 368.784 247.999C378.887 247.999 387.077 239.809 387.077 229.706C387.077 203.136 387.077 133.354 387.077 133.354C387.077 132.376 386.283 131.582 385.304 131.582Z",
    fill: "#FAA923"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.076 110.184L192.011 110.234L191.688 110.567L191.984 110.255C187.73 113.604 185 118.8 185 124.633V133.354C185 133.859 185.215 134.34 185.591 134.676L237.629 181.177C243.019 185.994 248.948 189.869 255.209 192.803C255.844 193.102 256.597 192.995 257.126 192.533C273.687 178.082 298.393 178.082 314.951 192.533C315.48 192.995 316.232 193.102 316.869 192.803C323.129 189.869 329.058 185.994 334.448 181.177L386.485 134.676C386.861 134.34 387.077 133.859 387.077 133.354V124.633C387.077 118.785 384.333 113.578 380.061 110.23C380.061 110.23 379.978 110.168 379.966 110.159C377.335 108.245 314.819 63.2784 314.819 63.2784C297.627 50.9071 274.451 50.9071 257.258 63.2793C257.258 63.2784 194.485 108.43 192.088 110.177L192.076 110.184Z",
    fill: "#E98D0A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.66 168.392C223.758 168.678 223.929 168.935 224.155 169.137L237.629 181.177C243.019 185.994 248.948 189.869 255.208 192.803C255.844 193.102 256.597 192.996 257.126 192.534C273.687 178.082 298.392 178.082 314.951 192.534C315.48 192.996 316.232 193.102 316.869 192.803C323.128 189.869 329.058 185.994 334.448 181.177L347.922 169.137C348.148 168.935 348.318 168.678 348.417 168.392C350.732 161.666 351.988 154.452 351.988 146.947C351.988 110.547 322.437 80.9966 286.038 80.9966C249.64 80.9966 220.088 110.547 220.088 146.947C220.088 154.452 221.345 161.666 223.66 168.392Z",
    fill: "#11BE6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.144 157.521L334.448 172.439C329.058 177.256 323.129 181.131 316.869 184.065C316.232 184.364 315.48 184.258 314.951 183.796C298.393 169.345 273.687 169.344 257.127 183.796C256.597 184.258 255.844 184.364 255.209 184.065C248.948 181.131 243.019 177.256 237.629 172.439L220.933 157.521C221.537 161.258 222.455 164.891 223.66 168.392C223.759 168.679 223.929 168.935 224.155 169.137L237.629 181.178C243.019 185.994 248.948 189.869 255.209 192.804C255.844 193.102 256.597 192.996 257.127 192.534C273.687 178.082 298.393 178.082 314.951 192.534C315.48 192.996 316.232 193.102 316.869 192.804C323.129 189.869 329.058 185.994 334.448 181.178L347.922 169.137C348.149 168.935 348.319 168.679 348.418 168.392C349.622 164.891 350.54 161.258 351.144 157.521Z",
    fill: "#0E8F51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.995 243.297C194.552 243.692 194.337 244.282 194.42 244.869C194.505 245.456 194.876 245.962 195.411 246.218C197.798 247.359 200.471 247.999 203.292 247.999C240.675 247.999 331.401 247.999 368.784 247.999C371.606 247.999 374.279 247.359 376.666 246.218C377.201 245.962 377.573 245.456 377.656 244.869C377.74 244.282 377.525 243.692 377.082 243.297L317.707 190.238C299.67 174.12 272.407 174.12 254.37 190.238L194.995 243.297Z",
    fill: "#FBC02A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.88 158.087L322.839 121.193C323.448 120.584 323.931 119.861 324.26 119.066C324.59 118.27 324.759 117.418 324.759 116.557C324.759 115.696 324.59 114.843 324.26 114.048C323.931 113.252 323.448 112.529 322.839 111.92C322.23 111.312 321.507 110.829 320.712 110.499C319.916 110.17 319.064 110 318.203 110C317.341 110 316.489 110.17 315.693 110.499C314.898 110.829 314.175 111.312 313.566 111.92L276.672 148.88C276.065 149.492 275.343 149.977 274.547 150.309C273.752 150.64 272.898 150.811 272.036 150.811C271.174 150.811 270.321 150.64 269.525 150.309C268.729 149.977 268.007 149.492 267.4 148.88L258.193 139.607C257.584 138.998 256.861 138.515 256.066 138.186C255.27 137.856 254.418 137.687 253.557 137.687C252.696 137.687 251.843 137.856 251.048 138.186C250.252 138.515 249.529 138.998 248.92 139.607C248.312 140.216 247.829 140.939 247.499 141.734C247.17 142.53 247 143.382 247 144.243C247 145.104 247.17 145.957 247.499 146.752C247.829 147.548 248.312 148.271 248.92 148.88L258.193 158.087C261.866 161.755 266.845 163.816 272.036 163.816C277.227 163.816 282.206 161.755 285.88 158.087Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetLinkSent);
export default __webpack_public_path__ + "static/media/resetLinkSent.d8fb2075caa96ec939c0c970cac84232.svg";
export { ForwardRef as ReactComponent };